/** @arg {string} id */
export function selectInput(id) {
  const elm = document.getElementById(id);
  if (elm instanceof HTMLInputElement) return elm;
  throw new Error(`'${id}' element not found`);
}

/** @arg {string} id */
export function selectSelect(id) {
  const elm = document.getElementById(id);
  if (elm instanceof HTMLSelectElement) return elm;
  throw new Error(`'${id}' element not found`);
}
